import { IonButton, IonCol, IonGrid, IonImg, IonRow } from "@ionic/react";
import React from "react";
import { Breadcrumb, BreadcrumbItem } from "../breadcrumb/Breadcrumb";
import "./ManageCapacityHeader.scss";

export interface ManageCapacityHeaderProps {
  breadcrumbItems?: BreadcrumbItem[];
  title?: string;
  actionName?: string;
  actionClick?: () => void;
  iconSrc?: string;
  segmentselected?:any;
}

export const ManageCapacityHeader: React.FunctionComponent<ManageCapacityHeaderProps> = (
  props: ManageCapacityHeaderProps
) => {
  const { breadcrumbItems, title, actionClick, actionName, iconSrc, segmentselected } = props;
  return (
    <IonGrid className="header">
      {breadcrumbItems && breadcrumbItems.length > 0 && (
        <IonRow>
          <IonCol size="12">
            <Breadcrumb items={breadcrumbItems} />
          </IonCol>
        </IonRow>
      )}
      {(title || actionName) && (
        <IonRow>
          <IonCol size="7">
            <h1 className="page-title">{title}</h1>
          </IonCol>
          <IonCol size="5" className="right">
            {actionName && (
              <IonButton className="btn-action" onClick={actionClick}>
                {iconSrc && <IonImg src={iconSrc} className="action-icon" />}
                {actionName}
              </IonButton>
            )}
          </IonCol>
        </IonRow>
      )}
    </IonGrid>
  );
};
